<template>
  <v-layout row>
    <v-flex xs12>
      <v-toolbar color="blue-grey">
        <v-toolbar-title>Post</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-badge
          overlap
          color="blue"
        >
          <span slot="badge">{{ item.points }}</span>
          <v-icon
            large
            color="yellow darken-2"
          >
            star
          </v-icon>
        </v-badge>
      </v-toolbar>
      <v-card>
        <v-card-text>
            <p>{{ item.story }}</p>
            <fullscreen ref="fullscreen" @change="fullscreenChange">
              <div :style="`height:${height};`">
                <slider ref="slider" :options="{loop:true}">
                    <slideritem
                        v-for="(media, index) in item.media"
                        :key="media.id"
                        :style="`width:${width};`"
                    >
                        <v-img
                            v-if="media.type == 'image'"
                            :src="media.url"
                            height="100%"
                            :contain="true"
                            style="cursor:pointer;"
                            @click="toggle(index)"
                        ></v-img>
                        <video
                            v-else
                            style="height:100%;cursor:pointer;"
                            @click="toggle(index)"
                        >
                            <source :src="media.url" :type="media.mimeType">
                        </video>
                    </slideritem>
                </slider>
              </div>
            </fullscreen>
        </v-card-text>
        <v-snackbar
          v-model="snackbar"
          color="error"
          :timeout="10000"
          :top="true"
        >
          {{ error }}
          <v-btn
            dark
            flat
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import carousel from 'v-owl-carousel'
  import fullscreen from 'vue-fullscreen'
  import { slider, slideritem } from 'vue-concise-slider'
  import Vue from 'vue'

  Vue.use(fullscreen)

  export default {
    props: ['id'],
    components: {
        carousel,
        slider,
        slideritem
    },
    data () {
      return {
        snackbar: false,
        error: "",
        fullscreen: false,
        slide: 1,
        width: '10em',
        height: '20em',
        slide: 1,
        post: {},
        item: {}
      }
    },
    methods: {
      toggle (index) {
          if (this.fullscreen) {
              return;
          }
          
          this.slide = index;
          this.$refs['fullscreen'].toggle();
      },
      fullscreenChange (fullscreen) {
          this.fullscreen = fullscreen;

          if (fullscreen) {
              this.width = '100%';
              this.height = '100%';

              this.$el.querySelector('.slider-pagination').hidden = true;

              const video = document.getElementsByTagName('video');
              
              for (let i = 0; i < video.length; i++) {
                  video[0].controls = true;
              }

              this.$refs['slider'].$emit('slideTo', this.slide);
          }
          else {
              this.width = '10em';
              this.height = '20em';

              this.$el.querySelector('.slider-pagination').hidden = false;

              const video = document.getElementsByTagName('video');
              
              for (let i = 0; i < video.length; i++) {
                  video[0].controls = false;
              }
          }
      },
      fullscreenSlideMovement (e) {
          if (e.key == 'ArrowLeft') {
              this.$refs['slider'].$emit('slidePre');
          }
          
          if (e.key == 'ArrowRight') {
              this.$refs['slider'].$emit('slideNext');
          }
      },
      populateItem () {
        this.item = {
          id: this.id,
          username: this.post.user.username,
          story: this.post.story,
          media: [],
          points: this.post.points
        };

        this.post.media.map((media, idx) => {
            const type = media.mime.split('/')[0];

            if (type != 'image' && type != 'video') {
              return;
            }
            
            this.item.media.push({
              id: media.id,
              type: type,
              mimeType: media.mime,
              url: media.url
            });
        });
      }
    },
    created () {
      this.$http.api.checkLogin('postDetails', {id: this.id});
      
      window.addEventListener('keyup', this.fullscreenSlideMovement);
    },
    mounted () {
      const url = `/posts/${this.id}`;

      this.$http.api.get(url)
      .then(response => {
        this.post = response.data;

        this.populateItem();
      })
      .catch(error => {
        if (error.response) {
          this.error = this.$http.api.getError(error).toString;
          this.snackbar = true;
        }
        else {
          console.dir(error);
        }
      });
    }
  }
</script>